export const SIMPLE = 'Simple'

export const SUBSCRIBE_TYPES = ['SignTelegram', 'SignCommunication', 'ClickOnLink']
export const GUESS_TYPES = [SIMPLE]
export const SPECIAL_QUEST_TYPES = ['CompleteSpecialQuests']
export const BUY_TYPES = [
  'GachaCashPurchase',
  'BrandPurchaseProductCount',
  'BrandPricePurchase',
  'PricePurchase',
  'PurchaseProductCount',
]

export const FAVOURITE_TYPES = ['UsePublicPromocode', 'AddFavoriteProduct']

export const ADD_TO_CART_TYPES = ['AddProductToCart']

export const PROMO_CODE_TYPES = ['UsePublicPromocode']

// subTypes
export const SIMPLE_LINK = 'simpleLink'
export const SIMPLE_TO_GA = 'simpleToGA'
export const SIMPLE_COMPLETED_PROFILE = 'simpleCompletedProfile'
export const SIMPLE_SECRET_WORD = 'simpleSecretWord'
